module.exports = __webpack_public_path__ + "img/not-found-whoops.26fdb7dc.svg";